
import React, { Component, Suspense, lazy } from "react";
import { Routes, Route, Navigate, HashRouter } from 'react-router-dom';
import Spinner from "../components/spinner/spinner";
import { LoginResponse } from "../models";
import { routes as SideMenuRoutes } from "../layouts/sidebar/sidemenu";
import * as _ from "lodash";
import history from "./history";
import EventEmitter, { Events } from "../services/eventemitter";
import MainLayout from "../layouts/mainLayout";
import ExtendedRouter from "./extendedRouter";
import { utils } from "../utils";
import { wglcsApiService } from "../services/WglcsApiService";
import i18n from "./../i18n";
import { I18nextProvider } from "react-i18next";
// import { useTranslation } from "react-i18next"
import { DetectEnvironment } from "../EnvironmentSettings";
import Login from "./../views/pages/Login/login";
import Forgetpassword from "./../views/pages/forgotPassword"
import NewPassword from "./../views/pages/newPassword";
import Register from "./../views/pages/register";

const LazyForgotPassword = lazy(() => import("./../views/pages/forgotPassword"));
const LazyNewPassword = lazy(() => import("./../views/pages/newPassword"));
// const LazyLogin = lazy(() => import("./../views/pages/Login/login"));
const LazyRegister = lazy(() => import("./../views/pages/register"));
const LazyLockScreen = lazy(() => import("./../views/pages/lockScreen"));
const LazySurveyQuestion = lazy(() => import("./../views/surveyQuestions/surveryQuestions"));
const LazyRouteSurveyQuestion = lazy(() => import("./../views/surveyQuestions/RouteSurveyQuestion"));
// const LazyRouteSurveyQuestion = lazy(() => import("./../views/surveyQuestions/newRoute"));
const LazyMsEmailForm = lazy(() => import("./../views/testingModule/MS-emailForm"));
const LazyChat = lazy(() => import("../views/loggedInResources/chat/chat"));
const LazyEmailForm = lazy(() => import("../components/chat/EmailForm"));
const LazyNewEmailForm = lazy(() => import("../components/transcript/viewEmailForm"));
const LazyVideoCall = lazy(() => import("../components/chat/VideoCall/VideoCall"));
// const LazyVideoCall = lazy(() => import("../components/chat/VideoCall/VideoCall"));
const LazyReportsMenu = lazy(() =>
    import("../views/WgReportSubMenu/Index")
);
class RouterState {
    currentUser: LoginResponse | null | undefined;
    webLang: string | null | undefined;
}

class Router extends Component<{}, RouterState> {
    constructor(props) {
        super(props);

        this.state = {
            currentUser: JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse,
            webLang: ""
        };

        EventEmitter.once(Events.onLogOut, this.onLogout);
        EventEmitter.on(Events.setWebContentLang, this.setWebContentLang);
    }

    setWebContentLang = (value: any) => {
        this.setState({ webLang: value }, () => {
            this.renderRoute()
        })
    }

    onLogin = (loginData: LoginResponse) => {
        localStorage.setItem("USER_DATA", JSON.stringify(loginData));
        this.setState({
            currentUser: loginData,
        });

        if (!utils.isElectronBuild()) {
            window.location.href = "/"
            // history.push("/");
            window.location.reload();
        }
    };

    onLogout = () => {
        wglcsApiService.deleteApiCache()
        localStorage.clear();

        this.setState({
            currentUser: null,
        });

        history.push("/");

        if (utils.isElectronBuild()) {
            window.myAPI.closeApp();
        }

        window.location.reload();
    };

    getUserPermittedRoutes = () => {

        var filteredRoutes = SideMenuRoutes()

        if (!utils.isLiveAdminsCompany(this.state.currentUser?.userLoginData?.empCompId!)) {
            filteredRoutes = filteredRoutes?.filter(x => x.path != "/report")
        }

        var routes = filteredRoutes.filter(
            (route) =>
                route.interfaceName === "" ||
                _.some(this.state.currentUser?.interfaces, (item) => item.interfaceName.toLowerCase() === route.interfaceName.toLowerCase())
        );
        return routes;
    };

    renderRoute = () => {
        const routPath = window.location.hash.substring(1) as any
        if (utils.isElectronBuild() && (routPath == "/dashboard" || routPath == "/report")) {
            window.location.reload()
        } else {
            history.push(routPath == "/dashboard" ? "/" : routPath);
        }
    }

    render() {

        var autoLoadOperatorPanel = this.state.currentUser?.interfaces?.some(i => i.interfaceName == "Operator Panel Auto Load") ?? false;


        if (this.state.currentUser == null) {
            if (!utils.isElectronBuild()) {
                return (
                    <ExtendedRouter basename={`${process.env.PUBLIC_URL}/`} history={history}>
                        <Routes>
                            <Route path="/login" element={<Login onSuccess={this.onLogin} />} />
                            <Route path="/newPassword" element={<NewPassword />} />
                            <Route path="/forgotPassword" element={<Forgetpassword />} />
                            {!DetectEnvironment.config.REACT_APP_IS_DISABLED_SIGNUP_ROUTE && <Route path="/signup" element={<Register />} />}
                            <Route path="*" element={<Navigate to="/login" replace />} />
                        </Routes>
                    </ExtendedRouter>
                );
            } else {
                return (
                    <HashRouter>
                        <Routes>
                            <Route path="/login" element={<Login onSuccess={this.onLogin} />} />
                            <Route path="/newPassword" element={<NewPassword />} />
                            <Route path="/forgotPassword" element={<Forgetpassword />} />
                            {!DetectEnvironment.config.REACT_APP_IS_DISABLED_SIGNUP_ROUTE && <Route path="/signup" element={<Register />} />}
                            <Route path="*" element={<Navigate to="/login" replace />} />
                        </Routes>
                    </HashRouter>
                )
            }
        }
        else {
            const webLang = i18n.changeLanguage(this.state.webLang as any) as any
            if (!utils.isElectronBuild()) {
                return (
                    <I18nextProvider i18n={webLang}>
                        <ExtendedRouter basename={`${process.env.PUBLIC_URL}/`} history={history}>
                            <Suspense fallback={<Spinner />}>
                                <Routes>
                                    {this.getUserPermittedRoutes().map((route) => {
                                        return (
                                            <Route
                                                key={route.path}
                                                path={route.path}
                                                element={
                                                    <MainLayout>
                                                        <Suspense fallback={<Spinner />}>
                                                            {React.createElement(route.component, {
                                                                ...route.componentProps,
                                                            })}
                                                        </Suspense>
                                                    </MainLayout>
                                                }
                                            />
                                        );
                                    })}
                                    <Route path="/Reports-Screen/submenu-item-1" element={<LazyReportsMenu />} />
                                    <Route path="/survey-question" element={<LazySurveyQuestion />} />
                                    <Route path="/logged-in-resources/:userId/:chatId" element={<LazyChat />} />
                                    <Route path="/testing-module/ms-email" element={<LazyMsEmailForm />} />
                                    <Route path="/emailform" element={<LazyEmailForm />} />
                                    <Route path="/Survey-questionwindow" element={<LazyRouteSurveyQuestion/>} />
                                    <Route path="/newemailform" element={<LazyNewEmailForm />} />
                                    <Route path="/pages/lockscreen" element={<LazyLockScreen />} />
                                    <Route path="*" element={<Navigate to={autoLoadOperatorPanel ? "/chat/:chatid" : "/dashboard"} replace />} />
                                </Routes>
                            </Suspense>
                        </ExtendedRouter>
                    </I18nextProvider>
                );
            } else {
                return (
                    <I18nextProvider i18n={webLang}>
                        <HashRouter>
                            <Suspense fallback={<Spinner />}>
                                <Routes>
                                    {this.getUserPermittedRoutes().map((route) => {
                                        return (
                                            <Route
                                                key={route.path}
                                                path={route.path}
                                                element={
                                                    <MainLayout>
                                                        <Suspense fallback={<Spinner />}>
                                                            {React.createElement(route.component, {
                                                                ...route.componentProps,
                                                            })}
                                                        </Suspense>
                                                    </MainLayout>
                                                }
                                            />
                                        );
                                    })}
                                    <Route path="/Reports-Screen/submenu-item-1" element={<LazyReportsMenu />} />
                                    <Route path="/survey-question" element={<LazySurveyQuestion />} />
                                    <Route path="/logged-in-resources/:userId/:chatId" element={<LazyChat />} />
                                    <Route path="/testing-module/ms-email" element={<LazyMsEmailForm />} />
                                      <Route path="/Survey-questionwindow" element={<LazyRouteSurveyQuestion/>} />
                                    <Route path="/emailform" element={<LazyEmailForm />} />
                                    <Route path="/newemailform" element={<LazyNewEmailForm />} />
                                    <Route path="/pages/lockscreen" element={<LazyLockScreen />} />
                                    <Route path="*" element={<Navigate to={autoLoadOperatorPanel ? "/chat/:chatid" : "/dashboard"} replace />} />
                                </Routes>
                            </Suspense>
                        </HashRouter>
                    </I18nextProvider>
                )
            }
        }
    }
}

export default Router;
